import React from 'react'
import cx from 'classnames'

import { SelectableBoxView } from 'components/_new/controls'

import s from './SelectableList.scss'


type Item = {
  key?: string
  value: string | number
}

type SelectableListProps = {
  children: any
  className?: string
  items: Array<Item>
  value: string | number
  onSelect: (data: Item) => void
  horizontal?: boolean
}

const SelectableList: React.FunctionComponent<SelectableListProps> = (props) => {
  const { children, className, items, value, onSelect, horizontal } = props

  return (
    <div className={className}>
      {
        items.map((item, index) => {
          const key       = item.key || index
          const isActive  = value === item.value
          const icon      = isActive ? 'checkmark' : null

          return (
            <SelectableBoxView
              key={key}
              className={cx(s.selectableItem, { [s.horizontal]: horizontal })}
              active={isActive}
              icon={icon}
              iconColor="brand"
              iconPosition="rightCenter"
              fullWidth
              onClick={() => onSelect(item)}
            >
              {children(item)}
            </SelectableBoxView>
          )
        })
      }
    </div>
  )
}


export default SelectableList
